import { MIN_COVERAGE } from './config';
import { ALL_NUTRIENT_KEYS } from './nutrients';
import type { MealEntry, NutrientKey } from './types';

/** kcal reales que aporta un registro. Si no se conocen, aporta 0 al reparto. */
function kcalOf(entry: MealEntry): number {
  const per100 = entry.per100g.kcal;
  if (per100 == null) return 0;
  return (per100 * entry.grams) / 100;
}

/**
 * Cobertura de un nutriente en un conjunto de registros: que porcentaje de las
 * kcal del dia viene de alimentos en los que ESE nutriente se conoce (SPEC 6.C).
 *
 * Se pondera por kcal y no por numero de alimentos a proposito: un suplemento
 * de 0 kcal con la vitamina D declarada no puede hacer creer que el dia entero
 * esta cubierto.
 */
export function coverageFor(entries: readonly MealEntry[], key: NutrientKey): number {
  let total = 0;
  let known = 0;

  for (const entry of entries) {
    const kcal = kcalOf(entry);
    if (kcal <= 0) continue;
    total += kcal;
    if (entry.per100g[key] != null) known += kcal;
  }

  if (total <= 0) return 0;
  return known / total;
}

/** Cobertura de todos los nutrientes del catalogo de una pasada. */
export function coverageForAll(entries: readonly MealEntry[]): Record<NutrientKey, number> {
  const out = {} as Record<NutrientKey, number>;
  for (const key of ALL_NUTRIENT_KEYS) {
    out[key] = coverageFor(entries, key);
  }
  return out;
}

/**
 * Por debajo del umbral, el nutriente se muestra como "datos insuficientes" y
 * queda fuera del calculo de deficits: no sabemos lo bastante como para decir
 * que falta (SPEC 7.1 y 7.5).
 */
export function hasEnoughCoverage(coverage: number): boolean {
  return coverage >= MIN_COVERAGE;
}
